import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  EmployeeResource,
  ContactResource,
  ContactHistoryResource,
  TaskInfoResource,
  CustomerContactDispResource,
  ContactHistoryOriginResource,
  VehicleInfoResource
} from '@blcloud/bl-ng-resource';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import {
  BlNgShareCommonModule,
  EmployeeGuideModule,
  ContactMemoGuideModule,
  ReceptionListModalModule,
  SendSingleMessageModalModule
} from '@blcloud/bl-ng-share-module';
import { VehicleGuideModule, TransitionDeciderModule } from '@blcloud/bl-ng-vehicle-customer-module';
import { ContactService } from '../../shared/contact/contact.service';
import { ResultFormModalComponent } from './result-form-modal.component';

/**
 * 結果入力モーダルモジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    BlNgShareCommonModule,
    EmployeeGuideModule.forRoot(),
    ContactMemoGuideModule.forRoot(),
    ReceptionListModalModule.forRoot(),
    SendSingleMessageModalModule.forRoot(),
    VehicleGuideModule.forRoot(),
    TransitionDeciderModule.forRoot()
  ],
  declarations: [
    ResultFormModalComponent
  ],
  entryComponents: [
    ResultFormModalComponent
  ],
})
export class ResultFormModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ResultFormModalModule,
      providers: [
        EmployeeResource,
        ContactResource,
        ContactHistoryResource,
        TaskInfoResource,
        CustomerContactDispResource,
        ContactHistoryOriginResource,
        VehicleInfoResource,
        ContactService,
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/result-form-modal/result-form-modal.module.ts